import { routes2 } from '@linqpal/models'

export const getUserInfo = async () => {
  try {
    const resp = await routes2.user.info()
    return resp
  } catch (err) {
    console.error(err)
    return null
  }
}
